module.exports = __webpack_public_path__ + "static/media/1POLICY46.ff6d7bb0.jpg";